export type IconThemeType = "web" | "responsive";

export interface IconProps {
    /** Name of the icon */
    name: string;
    /** Optional weight of the icon shape */
    weight?: string;
    /** Set this flag if the icon shape is filled */
    filled?: boolean;
}

export interface IconMetaData {
    /** Identifier for the icon */
    name: string;
    /** Array with supported weights */
    outlineWeights?: string[];
    /** Array with supported weights for filled icons */
    filledWeights?: string[];
    /** Support for legacy icons */
    legacyNames?: Record<string, LegacyIconDefinition>;
}

interface LegacyIconDefinition {
    /** The weight variant */
    weight?: string;
    /** If set to `true` the asset filename is composed with the `--filed` modifier */
    filled?: boolean;
}

export interface IconSetType {
    /** Namespace of the icon-set */
    ns: string;
    /** Path where icon-set assets are served from */
    assetsPath: string;
    /** Asset file extension (default '.svg') */
    fileExtension: string;
}
